import ecSettingsManage from './ecSettingsManage'
export default ecSettingsManage
